import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TermsAndConditionsComponent} from './terms-and-conditions.component';
import {I18nModule, UrlModule} from '@spartacus/core';
import {RouterModule} from '@angular/router';
import {FormsModule} from '@angular/forms';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {TermsConditionsEffects} from '@app/cart/store/effects/terms-conditions.effects';
import {termsAndConditionsReducer} from '@app/cart/store/reducers/terms-conditions.reducer';
import {termsAndConditionsFeatureKey} from '@app/cart/store/selectors/terms-conditions.selectors';

import '@udex/web-components/dist/Link';
import {DefaultModalModule} from '@app/shared/modal/default-modal.module';

@NgModule({
  declarations: [
    TermsAndConditionsComponent
  ],
  imports: [
    CommonModule,
    I18nModule,
    UrlModule,
    StoreModule.forFeature(termsAndConditionsFeatureKey, termsAndConditionsReducer),
    EffectsModule.forFeature([TermsConditionsEffects]),
    RouterModule,
    FormsModule,
    DefaultModalModule
  ],
  exports: [
    TermsAndConditionsComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
})
export class TermsAndConditionsModule {
}
